import axios from "axios";
import { api_url } from "../config/config";

const BASE = `${api_url}documents`;

/**
 * LS-693 — consultation transverse des documents d'un véhicule.
 *
 * Module en lecture seule : aucun dépôt ni suppression ici, ils restent dans
 * les modules d'origine (devis, financement) qui portent leurs propres règles
 * de verrouillage.
 */
const documentsApiService = {
  listerDocuments: (search = "") => axios.get(`${BASE}${search}`),

  // POST plutôt que GET côté API : l'archive accepte jusqu'à 100 uuids, ce qui
  // ne tient pas dans une URL. La réponse est un flux ZIP, d'où `blob` — les
  // erreurs 422 (sélection vide / plafonds dépassés) arrivent donc elles aussi
  // en Blob, cf. `messageErreurArchive` dans l'adapter.
  telechargerArchive: (payload) =>
    axios({
      url: `${BASE}/archive`,
      method: "POST",
      data: payload,
      responseType: "blob",
    }),
};

export default documentsApiService;
